import { Star } from "lucide-react";
import { m } from "@/paraglide/messages";
import { useFavorites } from "./use-favorites";

/** Star toggle shown on tool cards for signed-in users only. */
export function FavoriteButton({ toolId }: { toolId: string }) {
  const { signedIn, isFavorite, toggle } = useFavorites();
  if (!signedIn) return null;

  const active = isFavorite(toolId);
  return (
    <button
      type="button"
      aria-pressed={active}
      aria-label={active ? m.fav_remove() : m.fav_add()}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(toolId);
      }}
      className="rounded-full p-1.5 text-muted-foreground transition-colors hover:bg-muted/70 hover:text-foreground"
      data-testid={`fav-${toolId}`}
    >
      <Star
        className={`h-4 w-4 transition-colors ${active ? "fill-amber-400 text-amber-400" : ""}`}
      />
    </button>
  );
}
